<template>
  <div>
    <h1>{{ $t('silenceableGroup') }}</h1>
    <div class="zone-top" ref="midBox">
      <span style="float: left">
        <span class="label">{{ this.$t('group') }}:</span>
        <el-input style="width: 100px" clearable maxlength="3" v-model="searchInput" />
        <el-button class="blue-btn item" style="width: 40px" icon="el-icon-search" @click="search"></el-button>
        <span class="label" style="margin-left: 20px">{{ $t('total') }}:</span><span>{{ total }}</span>
      </span>
      <!-- <el-checkbox v-model="resound" @change="setAlarm" style="margin-right: 10px">{{ $t('resoundSoundersIfNewZoneInAlarm') }}</el-checkbox>
      <span class="operate">
        <el-tooltip :content="$t('import')" placement="bottom">
          <i class="iconfont icon-daochu" @click="uploadVisible = !uploadVisible"></i>
        </el-tooltip>
        <el-tooltip :content="$t('export')" placement="bottom">
          <i class="iconfont icon-daoru" @click="exportFile"></i>
        </el-tooltip>
      </span> -->
      <el-button class="blue-btn save-btn" style="position: relative; top: -6px" @click="saveAll">{{ $t('save') }}</el-button>
    </div>
    <el-scrollbar style="width: 100%">
      <Table
        style="width: 100%;margin-bottom: 5px"
        v-if="height"
        ref="tableRef"
        :dataSource="dataSource"
        :columns="tableColumns"
        @selectionChange="handleSelectionChange"
        :height="height"
      >
      </Table>
    </el-scrollbar>
    <Pagination
      v-if="dataSource.length > 0"
      :total="total"
      :pageSize="pageSize"
      :pageSizes="[20, 50, 100]"
      :currentPage="pageNumber"
      @change="pageSizeChange"
      style="margin: 10px 5% 0;"
    />
    <uploadModal :type="2" v-if="uploadVisible" :text="$t('importZoneDelays')" @close="uploadVisible = !uploadVisible" @upload="upload" />
  </div>
</template>

<script>
import { getZoneList, addZone, updateZone, deleteZone, patchGroupUpdate } from '../../api/zone'
import { getPanelDetail, setResoundZoneInAlarm } from '../../api/panel'
import { importZone, exportZone } from '../../api/importAndExport'
import uploadModal from '../../components/uploadModal.vue'
import Cookies from 'js-cookie'
import config from '../../common/config'
import { EventBus } from '../../store/eventBus'
import { ZONE0 } from './dataInfo'

export default {
  name: 'silenceableGroup',
  components: { uploadModal },
  mixins: [ZONE0],
  data () {
    return {
      dataSource: [],
      dataSourceCopy: [],
      resoundIfZoneInAlarm: '',
      tableColumns: [{
        prop: 'zone',
        label: this.$t('group'),
        // width: 300
      }, {
        prop: 'descr',
        label: this.$t('description'),
        // width: 500
      }, {
        prop: 'groupBySndCK',
        label: this.$t('groupBySndCK'),
        // width: 600
      }, {
        slotName: 'operation'
      }],
      yesOrNo: [{
        name: this.$t('yes'),
        value: 1
      }, {
        name: this.$t('no'),
        value: 0
      }],
      resound: false,
      uploadVisible: false,
      panelId: this.$route.query.panelId,
      panelNo: this.$route.query.panelNo,
      projectId: this.$route.query.projectId,
      selectData: [],
      height: 0,
      pageNumber: 1,
      total: 0,
      pageSize: 20,
      canLoadMore: false,
      searchInput: '',
      editData: [],
      editDataIndex: [],
      language: Cookies.get(config.language) || 'english',
      allChangeList: [],
      changeItem: []
    }
  },
  mounted () {
    const height = window.innerHeight - this.$refs.midBox.getBoundingClientRect().top - 114
    this.height = height < 200 ? 200 : height
    this.getZoneList()
    this.getPanelDetail()
    EventBus.$on('checkSave', (cb) => {
      const data = this.handleData()
      if (data.length > 0) {
        this.checkCommit()
      } else {
        cb()
      }
    })
  },
  methods: {
    getPanelDetail () {
      getPanelDetail({
        panelId: this.panelId,
        projectId: this.projectId
      }).then(res => {
        this.resoundIfZoneInAlarm = res.data.resoundIfZoneInAlarm
        if (this.resoundIfZoneInAlarm === 1) {
          this.resound = true
        }
      })
    },
    // getZoneList (isLoad) {
    getZoneList (pageObj = { pageNum: 1, pageSize: 20 }) {
      if (this.searchInput && (isNaN(this.searchInput) || this.searchInput < 1 || this.searchInput > 400)) {
        this.$message.error(this.$t('outOfRange'))
        this.searchInput = ''
        return
      }
      // if (isLoad && this.total > 0 && this.total <= (this.pageNumber - 1) * this.pageSize) {
      //   this.canLoadMore = false
      //   return
      // }
      // this.canLoadMore = true

      this.pageNumber = pageObj.pageNum
      if (pageObj.pageNum === 1) {
        this.pageSize = pageObj.pageSize
      }
      // this.pageSize = pageObj.pageSize

      const params = {
        panelNo: this.panelNo,
        projectId: this.projectId,
        type: 1,
        isPage: true,
        pageNumber: pageObj.pageNum,
        pageSize: this.pageSize,
        zone: this.searchInput
      }
      getZoneList(params).then(res => {
        const dataSource = res.data.map(n => {
          return {
            isEdit: true,
            id: n.id,
            zone: {
              value: n.zone
            },
            descr: {
              value: n.descr,
              type: 'input',
              maxlength: 32,
              change: (data, rowData, index) => {
                const value = data.value
                if (value.length > 32) {
                  this.$message.error(this.$t('tooLong'))
                  data.value = value.substr(0, 32)
                }
                this.addDataToArr(rowData, index)
              }
            },
            groupBySndCK: {
              value: n.groupBySndCK,
              type: 'select',
              width: 80,
              options: this.yesOrNo,
              change: (data, rowData, index) => {
                this.addDataToArr(rowData, index)
              }
            },
          }
        
        })
        // this.dataSource = this.dataSource.concat(dataSource)
        this.dataSource = this.dataInfo.concat(dataSource)
        delete this.dataSource[0].groupBySndCK.btn
        // delete this.dataSource[0].sndDelay.btn
        // delete this.dataSource[0].linkSndtoDET.btn
        // delete this.dataSource[0].linkSndtoMCP.btn
        this.dataSourceCopy = config.deepClone(this.dataSource)
        this.total = res.total
        // 滚到第一条
        this.$nextTick(() => {
          this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
        })
        // if ((this.total > 0 && this.total <= (this.pageNumber - 1) * this.pageSize) || !res.total) {
        //   this.canLoadMore = false
        // }
      })
    },
    search () {
      this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
      const data = this.handleData()
      if (data.length > 0) {
        this.checkCommit()
        return
      }
      if (this.searchInput && (isNaN(this.searchInput) || this.searchInput < 1 || this.searchInput > 400)) {
        this.$message.error(this.$t('outOfRange'))
        this.searchInput = ''
        return
      }
      this.pageNumber = 1
      this.dataSource = []
      this.getZoneList()
    },
    addRow () {
      const data = {
        isEdit: true,
        isAdd: true,
        zone: {
          value: 1,
          type: 'input'
        },
        sndDelay: {
          value: 0,
          type: 'input',
          change: (data) => {
            const value = +data.value
            if (value < 0 || value > 600 || isNaN(value)) {
              this.$message.error(this.$t('outOfRange'))
              data.value = 1
            }
          }
        },
        frDelay: {
          value: 0,
          type: 'input',
          change: (data) => {
            const value = +data.value
            if (value < 0 || value > 600 || isNaN(value)) {
              this.$message.error(this.$t('outOfRange'))
              data.value = 1
            }
          }
        },
        sndDelaytoDET: {
          value: 1,
          type: 'select',
          options: this.yesOrNo
        },
        sndDelaytoMCP: {
          value: 0,
          type: 'select',
          options: this.yesOrNo
        },
        frDelaytoDET: {
          value: 1,
          type: 'select',
          options: this.yesOrNo
        },
        frDelaytoMCP: {
          value: 1,
          type: 'select',
          options: this.yesOrNo
        }
      }
      this.dataSource.push(data)
    },
    delRow (id) {
      this.$msgbox({
        title: this.$t('prompt'),
        message: this.$t('sureDelete'),
        showCancelButton: true,
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            // instance.confirmButtonText = '执行中...'
            if (id) {
              const params = {
                id: id
              }
              deleteZone(params).then(res => {
                this.$message.success(this.$t('deleteSuccess'))
                instance.confirmButtonLoading = false
                this.getZoneList()
                done()
              }).catch(() => {
                instance.confirmButtonLoading = false
              })
            } else {
              this.$message.success(this.$t('deleteSuccess'))
              instance.confirmButtonLoading = false
              this.dataSource.pop()
              done()
            }
          } else {
            done()
          }
        }
      }).then(action => {
      })
    },
    saveRow (data) {
      const params = {
        panelNo: this.panelNo,
        projectId: this.projectId,
        zone: data.zone.value,
        descr: data.descr.value,
        groupBySndCK: +data.groupBySndCK.value
      }
      if (data.isAdd) {
        addZone(params).then(res => {
          this.$message.success(this.$t('saveSuccess'))
          this.dataSource = []
          this.pageNumber = 1
          this.total = 0
          this.getZoneList()
        })
      } else {
        params.id = data.id
        updateZone(params).then(res => {
          this.$message.success(this.$t('saveSuccess'))
          this.dataSource = []
          this.pageNumber = 1
          this.total = 0
          this.getZoneList()
        })
      }
    },
    editRow (data, index) {
      const item = {
        isEdit: true,
        id: data.id,
        zone: {
          value: data.zone,
          type: 'input'
        },
        sndDelay: {
          value: data.sndDelay,
          type: 'input'
        },
        frDelay: {
          value: data.frDelay,
          type: 'input'
        },
        sndDelaytoDET: {
          value: data.sndDelaytoDET,
          type: 'select',
          options: this.yesOrNo
        },
        sndDelaytoMCP: {
          value: data.sndDelaytoMCP,
          type: 'select',
          options: this.yesOrNo
        },
        frDelaytoDET: {
          value: data.frDelaytoDET,
          type: 'select',
          options: this.yesOrNo
        },
        frDelaytoMCP: {
          value: data.frDelaytoMCP,
          type: 'select',
          options: this.yesOrNo
        }
      }
      this.$set(this.dataSource, index, item)
    },
    cancelSaveRow (index) {
      this.$set(this.dataSource, index, this.dataSourceCopy[index])
    },
    setAlarm () {
      const params = {
        panelId: this.panelId,
        type: +this.resound
      }
      setResoundZoneInAlarm(params).then(res => {
        this.$message.success(this.$t('operateSuccess'))
      })
    },
    upload (file) {
      const params = new FormData()
      params.append('file', file)
      params.append('userId', Cookies.get(config.userId))
      params.append('panelNo', this.panelNo)
      params.append('projectId', this.projectId)
      params.append('lan', Cookies.get(config.language))
      if (file) {
        importZone(params).then(res => {
          this.$message.success(this.$t('importFilesuccess'))
          this.uploadVisible = false
          this.dataSource = []
          this.pageNumber = 1
          this.total = 0
          this.getZoneList()
        })
      }
    },
    exportFile () {
      if (this.searchInput && (isNaN(this.searchInput) || this.searchInput < 1 || this.searchInput > 400)) {
        this.$message.error(this.$t('outOfRange'))
        this.searchInput = ''
        return
      }
      exportZone({
        projectId: this.projectId,
        userId: Cookies.get(config.userId),
        panelNo: this.panelNo,
        type: 0,
        zone: this.searchInput,
        lan: this.language
      }).then(res => {
        this.$message.success(this.$t('exportFilesuccess'))
      })
    },
    saveAll (cb) {
      const data = this.handleData()
      if (data.length === 0) {
        this.$message.error(this.$t('notModified'))
        return
      }
      // if (this.selectData.length === 0) {
      //   this.$message.error(this.$t('pleaseChooseData'))
      //   return
      // }
      const arr = this.editData.map(data => {
        let item = {}
        if (data.id == 0) {
          item = {
            panelNo: this.panelNo,
            projectId: this.projectId,
            zone: data.zone.value,
            type: 1
          }
          if (this.changeItem.indexOf('groupBySndCK') != -1) {
            item.groupBySndCK = data.groupBySndCK.value
          }
        } else {
          item = {
            panelNo: this.panelNo,
            projectId: this.projectId,
            zone: data.zone.value,
            descr: data.descr.value,
            groupBySndCK: +data.groupBySndCK.value,
            type: 1
          }
        }
        if (data.id) {
          item.id = data.id
        }
        return item
      })
      patchGroupUpdate(arr).then(res => {
        this.$message.success(this.$t('saveSuccess'))
        this.dataSource = []
        // this.pageNumber = 1
        this.total = 0
        this.getZoneList({ pageNum: this.pageNumber, pageSize: this.pageSize })
        this.editDataIndex = []
        this.editData = []
        this.changeItem = []
        if (typeof cb === 'function') {
          cb()
        }
      })
    },
    handleSelectionChange (val) {
      this.selectData = val
    },
    loadMore () {
      this.getZoneList(true)
    },
    // 取消已编辑内容
    cancelEdit (done) {
      this.editDataIndex.map(n => {
        this.$set(this.dataSource, n, config.deepClone(this.dataSourceCopy[n]))
      })
      this.editDataIndex = []
      this.editData = []
      done()
    },
    // 将修改的值存起来，判断是否重复
    addDataToArr (data, index, value) {
      const _index = this.editDataIndex.indexOf(index)
      if (_index === -1) {
        this.editDataIndex.push(index)
        this.editData.push(data)
      } else {
        this.editData[_index] = data
      }
      if (value) {
        this.changeItem.push(value)
        if (value === 'linkSndtoDET') {
          data.linkSndtoDET.btn = (rowData, index) => {
            this.clickBtn(rowData, index)
          }
        }
        if (value === 'linkSndtoMCP') {
          data.linkSndtoMCP.btn = (rowData, index) => {
            this.clickBtn(rowData, index)
          }
        }
        if (value === 'sndDelay') {
          data.sndDelay.btn = (rowData, index) => {
            this.clickBtn(rowData, index)
          }
        }
        if (value === 'groupBySndCK') {
          data.groupBySndCK.btn = (rowData, index) => {
            this.clickBtn(rowData, index)
          }
        }
        this.$set(this.dataSource, index, data)
      }
    },
    // 点击保存
    clickBtn (rowData, index) {
      this.saveAll()
    },
    handleData () {
      const keys = ['descr', 'groupBySndCK']
      const data = []
      this.editDataIndex.map((n, i) => {
        const newData = this.editData[i]
        const oldData = this.dataSourceCopy[n]
        var notSave = true
        for (let i = 0, len = keys.length; i < len; i++) {
          const oldValue = oldData[keys[i]].value !== 0 ? oldData[keys[i]].value || '' : 0
          const newValue = newData[keys[i]].value !== 0 ? newData[keys[i]].value || '' : 0
          if (newValue != oldValue) {
            notSave = false
          }
        }
        if (!notSave) {
          data.push(newData)
        }
      })
      return data
    },
    checkCommit () {
      this.$msgbox({
        title: this.$t('prompt'),
        message: this.$t('unsavedRemind'),
        showClose: false,
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.saveAll(done)
          } else {
            this.cancelEdit(done)
            // done()
          }
        }
      }).then(action => {
      })
    },
    pageSizeChange (val) {
      const data = this.handleData()
      if (data.length > 0) {
        this.$msgbox({
          title: this.$t('prompt'),
          message: this.$t('unsavedRemind'),
          showClose: false,
          closeOnClickModal: false,
          showCancelButton: true,
          confirmButtonText: this.$t('sure'),
          cancelButtonText: this.$t('cancel'),
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              this.saveAll(done)
            } else {
              // this.cancelEdit(done)
              this.editDataIndex = []
              this.editData = []
              this.getZoneList(val)
              done()
            }
          }
        }).then(action => {
        })
      } else {
        this.getZoneList(val)
      }
      // this.getZoneList()
    }
  },
  beforeRouteLeave (to, from, next) {
    // 在token失效时,会跳转到/，此时不必拦截
    if (to.path !== '/') {
      const data = this.handleData()
      if (data.length > 0) {
        next(false)
        this.checkCommit()
      } else {
        next()
      }
    } else {
      next()
    }
  },
  beforeDestroy () {
    EventBus.$off('checkSave')
  }
}
</script>

<style lang="less" scope>
.zone-top {
  text-align: right;
  margin: 10px 0;
  // i {
  //   font-size: 30px;
  //   margin: 0 10px;
  //   cursor: pointer;
  // }
}
.icon-baocun, .icon-bianji {
  margin-left: 15px;
}
.active {
  color: @color-blue;
}
.save-btn {
  position: relative;
  margin-left: 20px;
}
h1 {
  font-size: 24px;
  font-weight: 400;
}
.item {
  margin-left: 20px;
}
.label {
  padding-right: 10px;
}
.operate {
  i {
    font-size: 30px;
    margin: 0 10px;
    cursor: pointer;
  }
}
</style>
